export const PRIVATETYPE = {
  public: 0, // 公开
  administrators: 1, //管理员设为私密
  notClass: 2, // 待分类
  privacy: 3, // 私密
};

// 本地使用的未整理画板
export const UNCLASSIFIED_BOARD = {
  board_id: 0,
  title: "未整理",
  updated_at: new Date("1990-01-01").getTime() / 1000,
  _pinyin: ["wei", "zheng", "li", "de", "cai", "ji"],
};

export const COLLAB_ROLES = {
  COLLECTOR: 2, // 采集者 - 只能添加采集
  EDITOR: 1, // 编辑者 - 可以添加、编辑、删除采集
} as const;

export type COLLAB_ROLE = (typeof COLLAB_ROLES)[keyof typeof COLLAB_ROLES];

// 用户类型常量
export const USER_TYPES = {
  CREATOR: "creator", // 画板创建者
  COLLABORATOR: "collaborator", // 协作成员
  INVITED: "invited", // 被邀请用户（status=0）
  VISITOR: "visitor", // 普通访客
} as const;

// 状态：0=邀请中，1=正常，2=已拒绝，3=已移除，4=主动退出
export enum MEMBER_INVITE_STATUS {
  INVITING = 0,
  NORMAL = 1,
  REJECTED = 2,
  REMOVED = 3,
  EXITED = 4,
}

// 0=邀请中，1=正常，2=已拒绝，3=已失效
export const INVITE_STATUS = {
  INVITING: 0,
  NORMAL: 1,
  REJECTED: 2,
  EXITED: 3,
} as const;

export type TINVITE_STATUS = (typeof INVITE_STATUS)[keyof typeof INVITE_STATUS];
